module.exports = __webpack_public_path__ + "static/img-2b0d6f8910efa43c7488747bc73d015b.png";